import { api } from "@/lib/api";
import { toHubMeeting } from "@/meetings/connectors";
import type { HubMeeting } from "@/meetings/model";

export type ZoomMeetingsStatus = {
  connected?: boolean;
  configured?: boolean;
  accountLabel?: string | null;
  authorizationUrl?: string | null;
  message?: string;
};

export async function fetchMeetings(): Promise<HubMeeting[]> {
  const payload = await api<unknown>("/api/meetings");
  const list = Array.isArray(payload)
    ? payload
    : payload && typeof payload === "object"
      ? (payload as { meetings?: unknown[] }).meetings || []
      : [];
  return list
    .map((row, index) => toHubMeeting(row, index))
    .filter((meeting): meeting is HubMeeting => Boolean(meeting))
    .sort((a, b) => String(a.start || "").localeCompare(String(b.start || "")));
}

export async function fetchZoomMeetingsStatus(): Promise<ZoomMeetingsStatus> {
  return api<ZoomMeetingsStatus>("/api/meetings/status");
}

export async function startZoomMeetingsConnect(): Promise<ZoomMeetingsStatus & { authorizationUrl?: string; ok?: boolean }> {
  return api("/api/integrations/zoom/connect", {
    method: "POST",
    body: JSON.stringify({}),
  });
}
